const EMAIL_VERIFICATION_STORAGE_KEY = 'akive.email-verification'

export const saveVerifiedEmail = (email, verificationPurpose) => {
  try {
    window.sessionStorage.setItem(EMAIL_VERIFICATION_STORAGE_KEY, JSON.stringify({
      email,
      verificationPurpose,
    }))
    return true
  } catch {
    return false
  }
}

export const getVerifiedEmail = (verificationPurpose) => {
  try {
    const storedValue = window.sessionStorage.getItem(EMAIL_VERIFICATION_STORAGE_KEY)
    if (!storedValue) return ''

    const verification = JSON.parse(storedValue)
    if (
      verification?.verificationPurpose !== verificationPurpose
      || typeof verification?.email !== 'string'
    ) return ''

    return verification.email
  } catch {
    return ''
  }
}

export const clearVerifiedEmail = () => {
  try {
    window.sessionStorage.removeItem(EMAIL_VERIFICATION_STORAGE_KEY)
  } catch {
    // 저장소 접근이 제한된 환경에서도 완료 흐름을 유지한다.
  }
}
